/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

/**
 *
 * @namespace classes.MathHelper
 */
const MathHelper = /** @lends classes.MathHelper*/ {
  /**
   * @param {number} x The value to clamp
   * @param {number} min The minimum value
   * @param {number} max The maximum value
   * @returns The value clamped between the min and max value
   */
  clamp: function (x, min, max) {
    return Math.min(Math.max(x, min), max);
  },

  /**
   * Check if the point is contained in the ElementRect
   * If the point is on the border, the method return true
   * @param {DOMRect} ElementRect The DomElement rect
   * @param {number} pointX The X coordinate of the point
   * @param {number} pointY The Y coordinate of the point
   */
  isInBound: function (ElementRect, pointX, pointY) {
    return pointX >= ElementRect.left && pointX <= ElementRect.right && pointY >= ElementRect.top && pointY <= ElementRect.bottom;
  },

  /**
   * Check that a value is in range defined by min and max both included.
   * @param {number} value
   * @param {number} min
   * @param {number} max
   * @returns True if the value is in range defined by min and max
   */
  isInRange: function (value, min, max) {
    return value >= min && value <= max;
  }
};

modulum("MathHelper", function (context, cls) {
  cls.MathHelper = MathHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = MathHelper;
}
